import { Shell, Title, Subtitle } from './styled'

const NotFoundPage = (): JSX.Element => (
  <Shell>
    <Title>404</Title>
    <Subtitle>
      We couldn&apos;t find what you&apos;re looking for. Double-check the link
      from your invite email.
    </Subtitle>
  </Shell>
)

export default NotFoundPage
